<template>
    <div>
        <sweet-modal blocking ref="purchaseProjectTaskOrder" class="modal" v-on:close="closePurchaseProjectTaskOrder">
            <div style="display:flex; justify-content: center;">
                <h2>Payment Entry Info</h2>
            </div>

            <el-table
                    :data="[form]"
                    style="width: 100%">
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        label="No."
                        prop="code"
                        width="100">
                </el-table-column>
                <el-table-column
                        label="Date Paid"
                        width="110">
                    <template slot-scope="scope">
                        <div v-if="scope.row.date">
                            {{scope.row.date}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="vendor.name"
                        label="Payment To"
                        width="120">
                </el-table-column>
                <el-table-column
                        :label="labelName">
                    <template slot-scope="scope">
                        <div v-if="scope.row.project">
                            {{scope.row.project.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        label="Task">
                    <template slot-scope="scope">
                        <div v-if="scope.row.task">
                            {{scope.row.task.name}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="bankAccount"
                        label="Bank Account"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="reference"
                        label="Reference"
                        width="110">
                </el-table-column>
                <el-table-column
                        label="Bank Balance">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.bankBalance)}}
                    </template>
                </el-table-column>
            </el-table>

            <el-row :span="24" style="margin: 20px 0;">
                Description
                <div>
                    {{form.description}}
                </div>
            </el-row>

            <!--TABLE START -->
            Items
            <el-table
                    size="mini"
                    border
                    :data="form.items"
                    style="width: 100%"
                    @cell-click="cellClick">
                <el-table-column
                        label="Transaction Type"
                        width="130">
                    <template slot-scope="scope">
                        {{scope.row.transactionType}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="No."
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.no}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Vendor Ref"
                        width="100">
                    <template slot-scope="scope">
                        {{scope.row.vendorRef}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Date"
                        width="100">
                    <template v-if="scope.row.date" slot-scope="scope">
                        {{moment(scope.row.date, 'X').format('DD MMM YYYY')}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Due Date"
                        width="100">
                    <template v-if="scope.row.dueDate" slot-scope="scope">
                        {{moment(scope.row.dueDate, 'X').format('DD MMM YYYY')}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Amount"
                        width="100">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.amount)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Other Allocations"
                        width="120">
                    <template slot-scope="scope">
                        {{formatPrice(scope.row.otherAllocations)}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="Left to Allocate">
                    <template slot-scope="scope">
                        {{scope.row.leftToAllocate}}
                    </template>
                </el-table-column>
                <el-table-column
                        label="This Allocations">
                    <template slot-scope="scope">
                        {{scope.row.thisAllocation}}
                    </template>
                </el-table-column>
            </el-table>
            <!--TABLE END -->

            <el-row :span="24" style="display:flex; justify-content: flex-end">
                <el-col :span="12">
                    <div class="bill">
                        <h4><span>Total Amount</span><span> {{formatPrice(form.totalAmount)}} </span> </h4>
                        <el-divider></el-divider>
                    </div>
                </el-col>
            </el-row>
        </sweet-modal>
    </div>
</template>

<script>
  import axios from 'axios'
  import moment from 'moment'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue';


  export default {
    name: "paymentEntryInfoModal",
    components:{
      SweetModal,

    },
    data() {
      return{
        moment:moment,
        action: 'editProject',
        labelName: 'Project',
        state: 'project',
        activePaymentEntryId: '',
        form:{
          code: '',
          project: {},
          task: {},
          vendor: {},
          date: '',
          bankAccount:'',
          reference: '',
          bankBalance: '',
          description: '',
          items:[],
          totalAmount: ''
        }
      }
    },
    methods:{
      // open modal purchases
      async openModalInfo(companyId, projectId, projectTaskId, paymentEntryId, state, manager){
        this.activePaymentEntryId = paymentEntryId
        console.log('companyId, paymentEntryId, state, manager', companyId, 'projectId', projectId, 'projectTaskId', projectTaskId, paymentEntryId, state, manager)
        try {
          const urlParts = this.buildUrl(state)
          this.labelName = urlParts.labelName
          this.state = state

          //Get task list
          if(!projectTaskId){
            this.action = 'editProject'
            //Get purchase item if project
            await this.getPaymentEntryItem(state, paymentEntryId)
          }else if(projectId && projectTaskId) {
            this.action = 'editTask'
            //Get purchase item if task
            await this.getPaymentEntryItem(state, paymentEntryId)
          }

          this.$refs.purchaseProjectTaskOrder.open()

        }catch (err){
          console.log(err)
        }
      },
      getPaymentEntryItem(type, paymentEntryId){
        return new Promise((resolve, reject) => {
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/paymentEntry/item?type=${type}&id=${paymentEntryId}`)
            .then(response => {
              // this.form.code = response.data.item.paymentEntry.code,
              this.form.project = response.data.item.project;
              this.form.task = response.data.item.projectTask;
              this.form.vendor = response.data.item.paymentEntry.vendor;
              this.form.date = response.data.item.paymentEntry.date;
              // this.form.bankAccount = response.data.item.paymentEntry.bankAccount
              this.form.reference = response.data.item.paymentEntry.reference;
              this.form.bankBalance = response.data.item.paymentEntry.bankBalance;
              this.form.description = response.data.item.paymentEntry.description;
              this.form.totalAmount =  response.data.item.paymentEntry.totalAmount;

              this.form.items = response.data.item.paymentEntry.items;

                resolve(response.data)
            }).catch(error =>{
            console.log(error)
            reject(error)
          })
        })
      },
      closePurchaseProjectTaskOrder(){
        this.form.vendor = {}
        this.form.task = {}
        this.form.project = {}
        this.form.date = ''
        this.form.vendorCurrency = ''
        this.form.vendorCredit = ''
        this.form.exchageRate = ''
        this.form.reference = ''
        this.form.deliverTo = ''
        this.form.itemsId = ''
        this.form.ifTax = ''
        this.form.isWth = ''
        this.form.description = ''
        //bill
        this.form.subTotal = '0'
        this.form.taxOf = '0'
        this.form.totalAmount = '0'
        this.form.includesTaxOf = '0'
        this.form.whtTaxAmount = '0'
        this.form.paymentToVendor = '0'
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      cellClick(row, column, event){
        console.log('row', row)
        console.log('column', column)
      },
      buildUrl(state) {
        let routeName = ''
        let labelName = ''
        let stateProjectId = ''
        let projectId = ''
        let stateTaskId = ''
        let taskId = ''
        let stateExpenseId = ''
        let stateProjectTasks = ''
        let stateTask = ''
        switch (state){
          case 'project':
            routeName = 'projects'
            labelName = 'Project'
            stateProjectId = 'projectId'
            stateProjectTasks = 'projectTasks'
            stateTaskId = 'projectTaskId'
            stateExpenseId = 'projectTaskPurchaseId'
            stateTask = 'projectTask'
            break;
          case 'engagement':
            routeName = 'engagements'
            stateProjectId = 'engagementId'
            stateTaskId = 'engagementTaskId'
            stateProjectTasks = 'engagementTasks'
            stateExpenseId = 'engagementTaskPurchaseId'
            labelName = 'Engagement'
            stateTask = 'engagementTask'
            break;
          case 'businessUnit':
            routeName = 'businessUnits'
            stateProjectId = 'businessUnitId'
            stateTaskId = 'businessUnitTaskId'
            stateProjectTasks = 'businessUnitTasks'
            stateExpenseId = 'businessUnitTaskPurchaseId'
            labelName = 'Business Unit'
            stateTask = 'businessUnitTask'
            break;
        }
        return {
          state: state,
          routeName: routeName,
          stateProjectId: stateProjectId,
          labelName: labelName,
          projectId: projectId,
          stateTaskId: stateTaskId,
          stateProjectTasks: stateProjectTasks,
          taskId: taskId,
          stateExpenseId: stateExpenseId,
          stateTask: stateTask }
      }
    }
  }
</script>

<style lang="less" scoped>
    /deep/.el-date-editor.el-input, .el-date-editor.el-input__inner {
        width:100%;
    }
    /deep/.sweet-modal-overlay{
        z-index:1000;
        .sweet-modal {
            max-width: 100% !important;
        }
    }
    .bill{
        text-align:right;
        h4{
            line-height:0.6;
            span{
                padding: 0 10px;
            }
        }
        .payment-to-vendor{
            background: rgb(227, 228, 230);
            h3{
                span{
                    padding: 0 10px;
                }
            }
        }
    }
</style>
